export const getCurrentDateAndTimeInSeconds = (): number => {
    const date = new Date();
    return date.getTime() / 1000;
};
